<template>
    <button :type="type" class="btn btn-outline-primary" :class="[size, optional_class]">
        <i class="bi" :class="icon"></i>
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'ButtonSearch',
    props: {
        text: {
            type: String,
            default: '検索',
        },
        icon: {
            type: String,
            default: 'bi-search',
        },
        type: {
            type: String,
            default: 'button',
        },
        size: {
            type: String,
            default: '',
        },
        optional_class: {
            type: String,
            default: '',
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
